import { useRecoilValue, useSetRecoilState } from 'recoil'
import { subDataState, userInfoState } from '@/util/states'

export const useFavorites = () => {
  const user = useRecoilValue(userInfoState)
  const subData = useRecoilValue(subDataState)
  const setSubData = useSetRecoilState(subDataState)

  const favoritePosts = subData?.favoritePosts || []

  const toggleFavorite = async (postId) => {
    if (!user?.uid || !subData || subData === 'pending') return

    try {
      await fetch(`/api/users/${user.uid}/favorites`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ postId }),
      })

      // Optimistically update favoritePosts inside subDataState
      const updatedFavorites = favoritePosts.includes(postId)
        ? favoritePosts.filter((id) => id !== postId)
        : [...favoritePosts, postId]

      setSubData({
        ...subData,
        favoritePosts: updatedFavorites,
      })
    } catch (error) {
      console.error('Error toggling favorite:', error)
    }
  }

  const isFavorited = (postId) => favoritePosts.includes(postId)

  return {
    favoritePosts,
    toggleFavorite,
    isFavorited,
  }
}
